// extracted by mini-css-extract-plugin
export default {"page":"Page_page__3MJye","header":"Page_header__eAUGH"};